import React from 'react';
import { Row, Col, Card, Button, Spin, Space, Alert, Tooltip } from 'antd';
import { ArrowLeftOutlined, ApartmentOutlined, FileTextOutlined, CheckCircleOutlined, FolderOpenOutlined, CloseCircleOutlined, EditOutlined, CommentOutlined } from '@ant-design/icons';
import { Fade } from 'react-reveal';
import { useDetalleReembolso } from './useDetalleReembolso';
import Flujo from './Flujo';
import Informacion from './Informacion';
import Autorizaciones from './Autorizaciones';
import Documentos from './Documentos';
import HistorialReembolso from './HistorialReembolso';
import ModalRechazarReembolso from './ModalRechazarReembolso';
import ModalActualizarReembolso from './ModalActualizarReembolso';

export default function DetalleReembolso() {
  const { data, loading, volver, reload, handleVobo, handlePagado, onRechazar, onActualizar, modalRechazarProps, modalActualizarProps } = useDetalleReembolso();

  if (loading) return <Spin />;
  if (!data) return null;

  return (
    <Fade>
      <div className="pagos-v2 pagos-v2__container">
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div className="card__titulo">Reembolso #{data.reembolsoID}</div>

        <Button icon={<ArrowLeftOutlined />} onClick={volver}>Volver</Button>

        {data.estaRechazado && (
          <Alert
            message={<span>Este Reembolso ha sido rechazado por <strong>{data.usuarioIDRechazo}</strong> Motivo: <strong>{data.motivoRechazo}</strong></span>}
            type="error"
            showIcon
          />
        )}

        <Row gutter={[16, 16]} style={{ alignItems: 'stretch' }}>
          <Col xs={24} lg={5} style={{ display: 'flex', flexDirection: 'column' }}>
            <Card title={<><ApartmentOutlined /> Flujo</>} size="small" type="inner" style={{ flex: 1, display: 'flex', flexDirection: 'column' }} bodyStyle={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Flujo data={data} />
            </Card>
          </Col>
          <Col xs={24} lg={5} style={{ display: 'flex', flexDirection: 'column' }}>
            <Card title={<><FileTextOutlined /> Información</>} size="small" type="inner" style={{ flex: 1 }}>
              <Informacion data={data} />
            </Card>
          </Col>
          <Col xs={24} lg={5} style={{ display: 'flex', flexDirection: 'column' }}>
            <Card
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>
                    <CheckCircleOutlined style={{ marginRight: 8 }} />
                    Autorizaciones
                  </span>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <Tooltip title="Actualizar Reembolso">
                      <Button
                        type="primary"
                        size="small"
                        icon={<EditOutlined />}
                        onClick={onActualizar}
                        disabled={data.estaRechazado}
                      />
                    </Tooltip>
                    <Tooltip title="Rechazar Reembolso">
                      <Button
                        danger
                        size="small"
                        icon={<CloseCircleOutlined />}
                        onClick={onRechazar}
                        disabled={data.estaRechazado}
                      />
                    </Tooltip>
                  </div>
                </div>
              }
              size="small"
              type="inner"
              style={{ flex: 1 }}
            >
              <Autorizaciones data={data} onVobo={handleVobo} onPagado={handlePagado} disabled={data.estaRechazado} />
            </Card>
          </Col>
          <Col xs={24} lg={5} style={{ display: 'flex', flexDirection: 'column' }}>
            <Card title={<><FolderOpenOutlined /> Documentos</>} size="small" type="inner" style={{ flex: 1 }}>
              <Documentos data={data} onReload={reload} />
            </Card>
          </Col>
          <Col xs={24} lg={4} style={{ display: 'flex', flexDirection: 'column' }}>
            <Card title={<><CommentOutlined /> Historial</>} size="small" type="inner" style={{ flex: 1, display: 'flex', flexDirection: 'column' }} bodyStyle={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <HistorialReembolso historial={data.historial} />
            </Card>
          </Col>
        </Row>
      </Space>
      </div>
      <ModalRechazarReembolso {...modalRechazarProps} />
      <ModalActualizarReembolso {...modalActualizarProps} />
    </Fade>
  );
}